import { Controller } from "@hotwired/stimulus"
import { showOverlay, hideOverlay } from "@/frontend/utils/modalHelpers"

const MAX_SEARCH_NUMBER = 3

export default class Search extends Controller {
  static targets = ["input", "form", "dropdown", "clear"]
  static values = {
    opened: { type: Boolean, default: false },
  }

  connect() {
    // set current term if present in the URL
    const searchTerm = new URLSearchParams(window.location.search).get("term")
    this.inputTarget.value = decodeURIComponent(searchTerm || "")
    this.boundClickOutside = (e) => this.clickOutside(e)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
  }

  open() {
    this.openedValue = true
  }

  hideDropdown() {
    this.dropdownTarget.classList.remove("visible")
  }

  showDropdown() {
    this.dropdownTarget.classList.add("visible")
  }

  saveRecentSearch(query) {
    // Save a search query to localStorage and limit the number of saved searches
    let searchlist = JSON.parse(localStorage.getItem("recentSearches")) || []
    if (!searchlist.includes(query)) {
      searchlist.unshift(query)
    }

    if (searchlist.length > MAX_SEARCH_NUMBER) {
      // Ensure that only the last MAX_SEARCH_NUMBER of entries are kept
      searchlist = searchlist.slice(0, MAX_SEARCH_NUMBER)
    }
    localStorage.setItem("recentSearches", JSON.stringify(searchlist))
  }

  submit() {
    if (!this.inputTarget.value) {
      this.dropdownTarget.classList.add("hidden")
    }
    const query = this.inputTarget.value.trim()
    if (query) {
      this.saveRecentSearch(query)
    }
    const encodedQuery = encodeURIComponent(query)
    Turbo.visit(`/artworks/search/${encodedQuery}?term=${encodedQuery}`)
  }

  clear() {
    // Clear the search input field and toggle the visibility of the clear button
    this.inputTarget.value = ""
  }

  // Listen events only when a dropdown is opened
  openedValueChanged() {
    document.removeEventListener("click", this.boundClickOutside)

    if (this.openedValue) {
      document.addEventListener("click", this.boundClickOutside)
      this.showDropdown()
      showOverlay()
    } else {
      this.inputTarget.blur()
      this.hideDropdown()
      hideOverlay()
    }
  }

  clickOutside(e) {
    const isInsideModal = this.element.contains(e.target)
    // Don't pass click events to links outside this dropdown
    if (!isInsideModal) e.preventDefault()
    if (isInsideModal) return

    this.openedValue = false
  }
}
